{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Ver todas las opciones",
  "Spoiler_Reveal_Tooltip": "Haz clic para revelar",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tuitea esto",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "El elemento está contraído",
  "Spoiler_Reveal_Video_CTA": "Mostrar video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Expandir imagen",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Ver todos los resultados",
  "Spoiler_Reveal_Image_Placeholder": "La imagen contiene un spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Control deslizante de búsqueda",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Puedes votar por más de una respuesta.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Mostrar más controles de audio",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Cerrar",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Cargando {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Avatar del usuario",
  "Preview_ReadMore_Label": "Leer más",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volumen",
  "Spoiler_Reveal_Gallery_Placeholder": "Esta galería contiene un spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Reservar ahora",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Dejar de silenciar",
  "Spoiler_Reveal_Gallery_CTA": "Mostrar galería",
  "Poll_Viewer_ShowLess_CTA": "Mostrar menos",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Silenciar",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anónimos",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Seguir",
  "VerticalEmbed_Products_Button": "Comprar ahora",
  "Poll_Viewer_Toast_Error_ServerDown": "No se pudo conectar al servidor. Inténtalo de nuevo más tarde.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} personas votaron por esta respuesta",
  "Poll_Viewer_VoteCount": "{{number}} votos",
  "VerticalEmbed_Events_Button": "Registrarse",
  "Spoiler_Reveal_Image_CTA": "Mostrar imagen",
  "Poll_Viewer_Toast_Error_Connection": "No hay internet. Verifica tu conexión.",
  "Poll_Viewer_Visibility_Owner_Footer": "Solo tú puedes ver los resultados.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} personas votaron por esta respuesta",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "El elemento está expandido",
  "Audio_Plugin_Cover_Alt": "Portada de audio",
  "Spoiler_Reveal_Video_Placeholder": "Este video contiene un spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Ver la entrada completa",
  "UploadFile_Viewer_Download": "Descargar {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}h",
  "VerticalEmbed_Units_Minute": "{{minutes}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
